import React, { useState, useCallback } from 'react';
import MarketBasedNotificationForm from './MarketBasedNotificationForm';
import MarketNotificationHistory from './MarketNotificationHistory';

function MarketBasedNotification() {
    const [refreshHistory, setRefreshHistory] = useState(true);

    const refreshNotificationList = useCallback(async (flag) => {
        setRefreshHistory(flag);
    }, []);

    return (
        <>
            <MarketBasedNotificationForm refresh={(flag) => refreshNotificationList(flag)} />
            <br />
            <MarketNotificationHistory
                refreshHistory={refreshHistory}
                refresh={(flag) => refreshNotificationList(flag)}
            />
        </>
    );
}

export default MarketBasedNotification;
